    mapboxgl.accessToken = 'pk.eyJ1IjoiZmFsbGVuYXJ0aXN0IiwiYSI6IkRHY2JKRWMifQ.m6rylJF-IEcmwtiRsVO1WA';

    var center = [51.5, -0.1];

    window.map = new mapboxgl.Map({
        container: 'map',
        center: center,
        zoom: 8,
        style: 'https://www.mapbox.com/mapbox-gl-styles/styles/mapbox-streets-v7.json'
    });